import { useNavigate } from 'react-router';
import AppHeader from '../components/AppHeader';
import DashboardCard from '../components/DashboardCard';
import AppPageLayout from '../layout/AppPageLayout';
import { getDashboardCards } from '../services/dashboardService';

function DashboardPage() {
  const navigate = useNavigate();
  const cards = getDashboardCards();

  return (
    <AppPageLayout>
      <AppHeader />

      <div className="mx-auto mt-8 w-full max-w-[540px] lg:mt-12 lg:max-w-[900px]">
        <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:gap-5">
          {cards.map((card) => (
            <DashboardCard
              key={card.id}
              title={card.title}
              backgroundClass={card.backgroundClass}
              onClick={card.to ? () => navigate(card.to) : undefined}
            />
          ))}
        </div>

        <div className="pt-5 text-center font-login text-[10px] text-[#5f6673] lg:pt-6 lg:text-[11px]">
          <p>Copyright 2022 JPH Lions Todos los derechos reservados</p>
        </div>
      </div>
    </AppPageLayout>
  );
}

export default DashboardPage;
